import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import * as actions from '../actions';
import * as c from '../constants';

class Inquire extends Component {
  static propTypes = {
    match: PropTypes.instanceOf(Object).isRequired,
    history: PropTypes.instanceOf(Object).isRequired,
    inquire: PropTypes.func.isRequired,
    inquiry_no: PropTypes.string.isRequired,
    data: PropTypes.instanceOf(Object).isRequired,
    isLoading: PropTypes.bool.isRequired,
    error_message: PropTypes.string.isRequired,
  }

  state = {
    error: '',
  }

  componentDidMount() {
    const { inquire, inquiry_no } = this.props;
    inquire(inquiry_no, this.inquired);
  }

  inquired = ({ data }) => {
    const biller_code = _.get(data, 'formable.biller_code');
    const { history, match } = this.props;
    if (!biller_code) {
      const billers = _.get(data, 'formable.billers') || [];
      if (Array.isArray(billers)) {
        history.push(`${match.url}/billers`);
        return;
      }
      this.setState({ error: 'Invalid Code!' });
      return;
    }
    history.push(`${match.url}/biller/${biller_code}`);
  }

  render() {
    const { error } = this.state;
    const { isLoading, data, error_message } = this.props;
    return (
      <div>
        { isLoading // eslint-disable-line
          ? (
            <div className="bg-dark text-white text-center d-flex justify-content-center align-items-center h-100 w-100" style={{ position: 'fixed' }}>
              <div>Loading...</div>
            </div>
          ) : ((!_.isEmpty(data) && !_.isEmpty(error)) ? (
            <div className="bg-dark text-white text-center d-flex justify-content-center align-items-center h-100 w-100" style={{ position: 'fixed' }}>
              <div>Please wait.</div>
            </div>
          ) : (
            <div className="bg-info text-white text-center d-flex justify-content-center align-items-center h-100 w-100" style={{ position: 'fixed' }}>
              <div>
                <div className="checkmark-wrapper">
                  <div className="checkmark-icon">
                    <svg
                      version="1.1"
                      id="Layer_1"
                      xmlns="http://www.w3.org/2000/svg"
                      x="0px"
                      y="0px"
                      viewBox="0 0 161.2 161.2"
                      enableBackground="new 0 0 161.2 161.2"
                      xmlSpace="preserve"
                    >
                      <path
                        className="path"
                        fill="none"
                        stroke="#17aa1c"
                        strokeMiterlimit="10"
                        d="M425.9,52.1L425.9,52.1c-2.2-2.6-6-2.6-8.3-0.1l-42.7,46.2l-14.3-16.4c-2.3-2.7-6.2-2.7-8.6-0.1c-1.9,2.1-2,5.6-0.1,7.7l17.6,20.3c0.2,0.3,0.4,0.6,0.6,0.9c1.8,2,4.4,2.5,6.6,1.4c0.7-0.3,1.4-0.8,2-1.5c0.3-0.3,0.5-0.6,0.7-0.9l46.3-50.1C427.7,57.5,427.7,54.2,425.9,52.1z"
                      />
                      <circle className="circle path" fill="none" stroke="#ffffff" strokeWidth="7" strokeMiterlimit="10" cx="80.6" cy="80.6" r="62.1" />
                      <polyline
                        className="check"
                        fill="none"
                        stroke="#ffffff"
                        strokeWidth="7"
                        strokeLinecap="round"
                        strokeMiterlimit="10"
                        points="113,52.8 74.1,108.4 48.2,86.4 "
                      />

                    </svg>
                  </div>
                </div>
                <h4>
                  {(false) && <div>{ !_.isEmpty(error) ? error : error_message }</div>}
                  <div id="alert-override" />
                </h4>
              </div>
            </div>
          ))
        }
      </div>
    );
  }
}

const mapStateToProps = ({ api }, { match }) => ({
  error_message: _.get(api, `error.${c.INQUIRE}.response.message`) || '',
  inquiry_no: match.params.inquiry_no,
  data: _.get(api, `${c.INQUIRE}.item`) || {},
  isLoading: api.loading.indexOf(c.INQUIRE) > -1,
});

export default connect(mapStateToProps, actions)(Inquire);
